export default "__VITE_ASSET__Cp0N8yVP__"